import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=7bfc2bc0"
import script from "./AddressDetail.vue?vue&type=script&lang=js"
export * from "./AddressDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports